/**
 * Copyright IBM Corp. 2022, 2026
 */

import Image from 'next/image'
import SocialBlock from '../social-block'
import { StandaloneLink, Text } from '@hashicorp/mds-react/components'
import s from './style.module.css'

export interface HeadshotProps {
	name?: string | null
	jobTitle?: string | null
	companyName: string
	href?: string | null
	isHrefExternal?: boolean | null
	image: {
		__typename?: 'FileField'
		url: string
		alt?: string | null
		width?: number | null
		height?: number | null
	}
	socialBlock?: {
		__typename?: 'SocialNetworkBlockRecord'
		socialItems: Array<{
			__typename?: 'SocialRecord'
			href: string
			name: string
			icon: { __typename?: 'IconNameRecord'; name: string }
		}>
	} | null
}

const Headshot = ({
	name,
	image,
	jobTitle,
	companyName,
	socialBlock,
	href,
	isHrefExternal,
}: HeadshotProps) => {
	return (
		<div>
			<div className={s.image}>
				<Image {...image} src={image.url} alt={image.alt} />
			</div>
			<Text.Body tag="p" size="300" color="strong" className={s.name}>
				{name}
			</Text.Body>
			<Text.Body tag="p" size="200" color="primary">
				{jobTitle}
			</Text.Body>
			<Text.Body tag="p" size="200" color="primary" className={s.companyName}>
				{companyName}
			</Text.Body>
			{socialBlock ? (
				<div className={s.social}>
					<SocialBlock {...socialBlock} />
				</div>
			) : null}
			{href ? (
				<StandaloneLink
					href={href}
					text="Bio"
					icon="chevron-right"
					iconPosition="trailing"
					isHrefExternal={isHrefExternal}
					className={s.link}
				/>
			) : null}
		</div>
	)
}

export default Headshot
